<div class="max-w-5xl mx-auto">
  <div class="page-container">
    <div class="relative page-edge-cut">
      <div class="form-card">
        <section class="space-y-3 mb-8">
          <h1 class="section-heading">
            {{
              "BUSINESS_GROUP.VOTING.TITLE"
                | translate: { groupName: groupName }
            }}
          </h1>
          <p class="text-xl text-dc-gray-light">
            {{ "BUSINESS_GROUP.VOTING.INTRODUCTION" | translate }}
          </p>
        </section>
        @if (deadline) {
          <div class="mb-8">
            <app-validation-message
              type="info"
              [content]="{
                title:
                  'BUSINESS_GROUP.VOTING.DEADLINE'
                  | translate: { date: deadline },
              }"
            />
          </div>
        }
        <form [formGroup]="form" (ngSubmit)="castVote()" class="space-y-8">
          @for (position of positions; track position.id; let index = $index) {
            <fieldset class="space-y-4">
              <legend class="field-label mb-4">
                {{
                  (position.selectionType === "multiple"
                    ? "BUSINESS_GROUP.VOTING.SELECT_MULTIPLE"
                    : "BUSINESS_GROUP.VOTING.SELECT_CANDIDATE"
                  )
                    | translate
                      : {
                          position: position.position,
                          count: position.maxSelections,
                        }
                }}
              </legend>
              @for (
                candidate of position.nominatedPersons;
                track candidate.id
              ) {
                <label
                  class="flex items-center gap-4 text-dc-navy cursor-pointer"
                >
                  <input
                    [type]="
                      position.selectionType === 'multiple'
                        ? 'checkbox'
                        : 'radio'
                    "
                    [name]="'bgc-vote-' + position.id"
                    [value]="candidate.id"
                    [checked]="
                      form.controls.votes.at(index).value.includes(candidate.id)
                    "
                    [disabled]="
                      position.selectionType === 'multiple' &&
                      form.controls.votes.at(index).value.length >=
                        position.maxSelections &&
                      !form.controls.votes
                        .at(index)
                        .value.includes(candidate.id)
                    "
                    (change)="selectCandidate(index, candidate.id, $event)"
                    class="h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy disabled:cursor-not-allowed"
                  />
                  <span>{{ candidate.name }}</span>
                </label>
              } @empty {
                <p class="text-dc-gray-light">
                  {{ "BUSINESS_GROUP.VOTING.NO_CANDIDATES" | translate }}
                </p>
              }
              @if (
                form.controls.votes.at(index).touched &&
                form.controls.votes.at(index).hasError("required")
              ) {
                <p class="fields-error-container">
                  {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
                </p>
              }
            </fieldset>
          }
          <div class="btn-section buttons-group">
            <app-button
              type="submit"
              classesName="btn-edge-cut btn-width-auto"
              [label]="'BUSINESS_GROUP.VOTING.CAST_VOTE' | translate"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
